<template>
  <div v-show="show" class="fixed inset-0 z-50 overflow-y-auto">
    <div
      v-show="show"
      class="
        flex
        items-end
        justify-center
        min-h-screen
        px-4
        pt-4
        pb-20
        text-center
        sm:block sm:p-0
      "
    >
      <div
        @click="closeModal()"
        transition:enter="ease-out duration-300"
        transition:enter-start="opacity-0"
        transition:enter-end="opacity-100"
        transition:leave="ease-in duration-200"
        transition:leave-start="opacity-100"
        transition:leave-end="opacity-0"
        class="fixed inset-0 transition-opacity"
      >
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <div
        v-show="show"
        transition:enter="ease-out duration-300"
        transition:enter-start="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        transition:enter-end="opacity-100 translate-y-0 sm:scale-100"
        x-transition:leave="ease-in duration-200"
        x-transition:leave-start="opacity-100 translate-y-0 sm:scale-100"
        x-transition:leave-end="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        class="
          inline-block
          relative
          px-4
          pt-5
          pb-4
          overflow-hidden
          text-left
          align-bottom
          transition-all
          transform
          bg-white
          rounded-lg
          shadow-xl
          sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6
          modalVue
        "
        role="dialog"
      >
        <div
          class="
            absolute
            top-2
            right-3
            cursor-pointer
            z-10
            bg-white
            rounded-full100
            w-6
            h-6
            flex
            justify-center
            items-center
			closeModal
          "
          @click="closeModal()"
        >
          <font-awesome-icon icon="times" size="lg" />
        </div>
        <div class="flex flex-col justify-between w-full mt-2">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["show"],
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>